import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import _ from 'lodash'
import { Message } from '@paypalcorp/worldready-react'
import { formatFileSize, removeExtraSlashes } from '../helper'

class Upload extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      selectedFilesToUpload: [],
      errorMsg: { msg: '', status: 'success' },
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { errorMsg } = this.state

    if (!_.isEqual(errorMsg, prevState.errorMsg)) {
      setTimeout(
        () => this.setState({ errorMsg: { msg: '', status: 'success' } }),
        10000,
      )
    }
  }

  browseFiles = () => {
    this.fileInput.click()
  }

  onUploadFilesClick = () => {
    const { selectedFilesToUpload } = this.state
    if (selectedFilesToUpload.length > 0) {
      const filesToUpload = this.updateUploadFilesPathAndStatus(
        selectedFilesToUpload,
      )
      this.props.validateFileBeforeUpload(filesToUpload)
    }
    this.props.setUploadFileBoxVisibility(false)
  }

  updateUploadFilesPathAndStatus = (selectedFilesToUpload) => {
    const { baseFolder, filesToUpload } = this.props
    selectedFilesToUpload.map((item) => {
      item.basePath = baseFolder
    })
    return this.removeDuplicateFiles(selectedFilesToUpload, filesToUpload)
  }

  removeDuplicateFiles = (newFiles, currentFiles) => {
    let uniqueResultTwo = newFiles.filter(function (file1) {
      return !currentFiles.some(function (file2) {
        if (file1.basePath) {
          return (
            file1.name === file2.name &&
            removeExtraSlashes(`${file1.basePath}/${file1.name}`) ===
              removeExtraSlashes(`${file2.basePath}/${file2.name}`)
          )
        }
        return file1.name === file2.name
      })
    })
    return uniqueResultTwo.length > 0
      ? currentFiles.concat(uniqueResultTwo)
      : currentFiles
  }

  handleChange = (files) => {
    this.setState({ errorMsg: { msg: '', status: 'success' } })
    const { selectedFilesToUpload } = this.state
    const filesToUpload = Array.from(files)
    const allowedFile = this.validateSelectedFiles(filesToUpload)
    const result = this.removeDuplicateFiles(allowedFile, selectedFilesToUpload)
    this.setState({ selectedFilesToUpload: result })
  }

  validateSelectedFiles = (filesToUpload) => {
    const validateResult = this.props.validateSelectedFilesToUpload(
      filesToUpload,
    )

    if (validateResult.improperFilesErrMsg !== '') {
      this.updateErrorMessage(validateResult.improperFilesErrMsg)
    }
    if (validateResult.dotFilesErrMsg !== '') {
      this.updateErrorMessage(validateResult.dotFilesErrMsg)
    }
    if (validateResult.folderNotAllowedErrMsg !== '') {
      this.updateErrorMessage(validateResult.folderNotAllowedErrMsg)
    }
    return validateResult.allowedFile
  }

  removeFilesSelectedToUpload = (name) => {
    const { selectedFilesToUpload } = this.state
    let filteredFiles = selectedFilesToUpload.filter((e) => e.name !== name)
    this.setState({ selectedFilesToUpload: filteredFiles })
  }

  updateErrorMessage = (msg) => {
    this.setState({
      errorMsg: { msg, status: 'error' },
    })
  }

  renderSelectedFiles = () => {
    const { selectedFilesToUpload } = this.state
    let files = []
    if (selectedFilesToUpload.length > 0) {
      for (let i in selectedFilesToUpload) {
        files.push(
          selectedFilesToUpload[i].name && selectedFilesToUpload[i].size && (
            <div
              className="upload__list-content"
              key={selectedFilesToUpload[i].name}
            >
              <div className="upload__list-name-type-size">
                <div className="ppvx__text--md upload__list-name">
                  {selectedFilesToUpload[i].name}
                </div>
                <div className="upload__list-type-size">
                  <div className="upload__list-size">
                    <Message id="upload.size" />:{' '}
                    {formatFileSize(selectedFilesToUpload[i].size)}
                  </div>
                  <div className="upload__list-type">
                    <Message id="upload.type" />:{' '}
                    {selectedFilesToUpload[i].type}
                  </div>
                </div>
              </div>
              <div
                className="upload__list-delete"
                onClick={() =>
                  this.removeFilesSelectedToUpload(
                    selectedFilesToUpload[i].name,
                  )
                }
              >
                <span className="ppvx_icon ppvx_icon--size_md ppvx_icon-trash" />
              </div>
            </div>
          ),
        )
      }
    } else {
      files.push(
        <div className="upload__no-files" key="no_files_to_upload">
          <Message id="upload.noFilesToUpload" />
        </div>,
      )
    }

    return files
  }

  renderErrorMessage = () => {
    const { errorMsg } = this.state
    return (
      errorMsg.msg !== '' && (
        <div className="upload__err-msg show">
          <div
            className={`ppvx_alert ppvx_alert--type_${errorMsg.status}`}
            role="alert"
          >
            {errorMsg.msg}.
          </div>
        </div>
      )
    )
  }

  renderUploadAction = () => {
    const { selectedFilesToUpload } = this.state
    return (
      <div className="upload-button-container">
        <div className="upload__buttons">
          <button
            className="ppvx_btn ppvx_btn--secondary ppvx_btn--size_md flexCenter"
            onClick={() => this.props.setUploadFileBoxVisibility(false)}
          >
            <span className="uploadButton">
              <Message id="buttons.cancel" />
            </span>
          </button>
          <button
            className={`ppvx_btn ppvx_btn--size_sm flexCenter ${
              selectedFilesToUpload.length === 0 ? 'disable__button' : ''
            }`}
            disabled={selectedFilesToUpload.length === 0}
            onClick={() => this.onUploadFilesClick()}
          >
            <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-upload" />
            <span>
              <Message id="buttons.uploadFile" />
            </span>
          </button>
        </div>
      </div>
    )
  }

  renderSelectedFilesToUpload = () => {
    return (
      <div className="upload__list-container">{this.renderSelectedFiles()}</div>
    )
  }

  renderDrapAndDropArea = () => {
    return (
      <div className="upload__drag_drop-container">
        <Dropzone onDrop={(acceptedFiles) => this.handleChange(acceptedFiles)}>
          {({ getRootProps }) => (
            <div className="popup-upload" {...getRootProps()}>
              <div className="upload-body">
                <div>
                  <Message id="upload.drag" />
                </div>
                <div>
                  <Message id="upload.or" />
                </div>
                <div className="browse-file">
                  <div>
                    <input
                      ref={(fileInput) => (this.fileInput = fileInput)}
                      id="uploadFile"
                      type="file"
                      name="uploadFile"
                      multiple
                      encType="multipart/form-data"
                      className="upload__input-box"
                      onChange={(e) => this.handleChange(e.target.files)}
                    />
                  </div>
                  <a onClick={() => this.browseFiles()}>
                    <Message id="upload.browseFiles" />
                  </a>
                </div>
              </div>
            </div>
          )}
        </Dropzone>
      </div>
    )
  }

  renderUploadHeader = () => {
    const { errorMsg } = this.state
    return (
      <header className="ppvx_modal-header ppvx_modal-header--no-logo">
        <div className="ppvx_modal-header__action">
          <div className="upload__header">
            <div className="upload__label">
              <Message id="upload.label" />
            </div>
          </div>
        </div>
        {errorMsg.msg !== '' && (
          <div className="upload__err-msg-container">
            {this.renderErrorMessage()}
          </div>
        )}
        <div className="ppvx_modal-header__close">
          <button
            className="ppvx_modal-header__close-btn"
            data-action-close-modal="true"
            id="hide-my-overpanel"
            aria-label="close lightbox"
            onClick={() => this.props.setUploadFileBoxVisibility(false, {})}
          />
        </div>
      </header>
    )
  }

  render() {
    const { showUpload } = this.props
    return (
      <div
        className="ppvx_modal-backdrop"
        id="myOverpanel3"
        role="dialog"
        aria-hidden={showUpload ? 'false' : 'true'}
        data-ppvx_modal-background-close="true"
      >
        <article className="ppvx_modal upload__article" tabIndex="-1">
          {this.renderUploadHeader()}
          {this.renderDrapAndDropArea()}
          <section className="ppvx_modal__contents upload__modal-content flexCenter">
            {this.renderSelectedFilesToUpload()}
            {this.renderUploadAction()}
          </section>
        </article>
      </div>
    )
  }
}
export default Upload
